/**
 * DevExtreme (esm/ui/date_box.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import DateBox from "../__internal/ui/date_box/m_date_box";
export default DateBox;